import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/html5': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M0 32L34.9 427.8 191.5 480 349.1 427.8 384 32H0zM308.2 159.9H124.4L128.5 209.3H304.1L290.5 357.7 192.6 384.7V385H191.5L92.8 357.7 86.8 281.9H134.5L138 320 191.5 334.5 245.2 320 251.2 257.8H84.3L71.5 112.2H312.6L308.2 159.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/html5.js
// module id = kQfl
// module chunks = 144